import { render } from "./as-labeled-block.vue?vue&type=template&id=105c1c89&scoped=true&ts=true"
import script from "./as-labeled-block.vue?vue&type=script&lang=ts"
export * from "./as-labeled-block.vue?vue&type=script&lang=ts"

import "./as-labeled-block.vue?vue&type=style&index=0&id=105c1c89&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105c1c89"]])

export default __exports__